<template>
    <div class="user-list">
        <div class="main-content-90">
            <div class="table-container">
                <el-table :data="tableData" style="width: 100%" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle">
                    <el-table-column align="center" prop="em_number" label="获得优惠券次数" min-width="18%">
                        <template slot-scope="scope">
                            <span><i class="icon iconfont icon-dzqgl"></i>&nbsp;x&nbsp;{{scope.row.em_number}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="name" label="姓名" min-width="10%">
                    </el-table-column>
                    <el-table-column align="center" prop="belong_store_name" label="门店" min-width="10%">
                    </el-table-column>
                    <el-table-column align="center" prop="phone" label="手机号" min-width="13%">
                    </el-table-column>
                    <el-table-column align="center" prop="car_type" label="车型" min-width="10%">
                    </el-table-column>
                    <el-table-column align="center" prop="car_number" label="车牌号" min-width="10%">
                    </el-table-column>
                    <el-table-column align="center" prop="last_cost_time" label="最近一次消费" min-width="20%">
                        <template slot-scope="scope">
                            <span>{{scope.row.last_cost_time | formatDate}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="last_cost" label="消费金额" min-width="10%">
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            tableData: []
        }
    },
    created () {
        this.init();
    },
    methods: {
        changeTableHeaderStyle({row, rowIndex}) {
            return 'color:black; font-weight: bold;';
        },
        changeTableStyle ({row, column, rowIndex, columnIndex}) {
            if(columnIndex == 4) {
                return 'color: #db3d3d;'
            }
            return 'color: #000;'
        },
        init () {
            this.axios.get('customer_list')
            .then(res => {
                this.tableData = res.data.data;
            })
        }
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);
@import url(https://at.alicdn.com/t/font_976438_kvydgtappuo.css);

.user-list {
    background-color: #F9F9F9;
}
.user-list .icon {
    color: #84DFBF;
}
</style>




// WEBPACK FOOTER //
// src/pages/userManage/UserList.vue